<div class="page">
    <div class="page-head">
        <h2>{{ pageTitle() || 'Messaging' }}</h2>
        <p>
            Rules decide <b>which channels</b> each message goes out on, templates decide
            <b>what it says</b>, providers decide <b>who sends it</b>, and the outbox shows
            <b>what happened</b>.
        </p>
    </div>

    <div class="card tabs-card">
        <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)">
            <p-tablist>
                <p-tab value="rules"><i class="pi pi-sliders-h"></i> Rules</p-tab>
                <p-tab value="templates"><i class="pi pi-file-edit"></i> Templates</p-tab>
                <p-tab value="providers"><i class="pi pi-server"></i> Providers</p-tab>
                <p-tab value="outbox"><i class="pi pi-inbox"></i> Outbox</p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel value="rules">
                    @if (activeTab() === 'rules') { <app-messaging-rules /> }
                </p-tabpanel>
                <p-tabpanel value="templates">
                    @if (activeTab() === 'templates') { <app-message-templates /> }
                </p-tabpanel>
                <p-tabpanel value="providers">
                    @if (activeTab() === 'providers') { <app-communication-config /> }
                </p-tabpanel>
                <p-tabpanel value="outbox">
                    @if (activeTab() === 'outbox') { <app-notifications /> }
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
</div>
